import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../../../services/_base.service';
import { ICRUDService } from '../../../shared/crud-manager/crud.interface';
import { catchError, throwError } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class AdminInvoicingInfoService extends BaseService implements ICRUDService {
  params = [
    'company_name',
    'rut',
    'activity',
    'city',
    'district',
    'address',
    'legal_representative_name',
    'legal_representative_rut',
    'electronic_signature_url',
    'rut_front_url',
    'rut_back_url',
  ];

  create(value) {
    return this.http.post(
      `${this.adminURL}/invoicing_infos/`,
      { invoicing_info: this.permitParams(value, ...this.params) },
      this.getParams(),
    ).pipe(
      catchError((error) => {
        console.error('Error creating invoicing info:', error);
        return throwError(() => error);
      }),
    );
  }

  update(id: number, value) {
    return this.http.put(
      `${this.adminURL}/invoicing_infos/${id}`,
      { invoicing_info: this.permitParams(value, ...this.params) },
      this.getParams(),
    ).pipe(
      catchError((error) => {
        console.error('Error updating invoicing info:', error);
        return throwError(() => error);
      }),
    );
  }
}